<template>
  <div class="modal fade edit-promo-modal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"
    id="edit-promo-modal">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="container py-4 px-4">
          <b>
            <h4 style="text-align: center; color: #AC8400">Edit Promotion</h4>
          </b>

          <InputLabel class="px-3" v-model="data.title" label="Title" placeholder="" type="text" :required="true" :errorMessage="errors.title"/>

          
          <div class="mt-3 px-3">
            <label class="form-label">Maximum Advanced Purchase Period</label>
            <div class="row">
              <div class="col-2">
                <label class="form-label">Up to</label>
              </div>
              <div class="col-3">
                <InputLabel v-model="data.value" type="number" :required="true" :errorMessage="errors.value" />
              </div>
              <div class="col-3">
                <select class="form-control" :required="true" v-model="data.type">
                  <option v-for="(item, index) in duration_options" :key="index" :value="item.value" :selected="item.value == data.type">{{ item.name }}</option>
                </select>
                <span class="invalid-feedback">{{ errors.type ? errors.type : '' }}</span>
              </div>

            </div>
          </div>

          <div class="row mt-3 px-3">
            <div class="col-6">
              <InputLabel v-model="data.start_date" label="Start Date" type="date" required :errorMessage="errors.start_date"/>
            </div>

            <div class="col-6">
              <InputLabel v-model="data.end_date" label="End Date" type="date" required :errorMessage="errors.end_date"/>
            </div>
          </div>

          <div class="row mt-3 px-3">
            <div class="col-6">
              <label class="form-label">Status</label>
            </div>
          </div>

          <div class="d-flex flex-row">
            <div v-for="(item, index) in advanced_options" :key="index">
              <label class="radio radio-gold ml-3">
                <input type="radio" name="advancedStatusPeriod" v-bind:value="item.value"
                  v-model="data.status">
                <div class="d-flex flex-row child-flex-class">
                  <span>{{ item.name }}</span>
                </div>
                <span class="checkmark"></span>
              </label>
            </div>

          </div>

          <div style="text-align: center">
            <button class="btn mr-1"
              style="width: 100px; color: #AC8400; background-color: white; border-color: #AC8400;"
              @click="hideModal('#edit-promo-modal')">
              Cancel
            </button>
            <button class="btn" style="width: 100px; color: white; background-color: #AC8400; border-color: #AC8400;"
              @click="handleSubmit">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { type } from 'jquery';
import InputLabel from '../../../components/UI/InputLabel.vue';


export default {
  name: "edit-modal",
  
  components: {
    InputLabel
  },

  props: {
    duration_options: {
      type: Array,
      required: true
    },

    data: {
      type: Object,
      required: false,
      default: {
        id: null,
        title: '',
        start_date: '',
        end_date: '',
        status: '',
        type: '',
        value: '',
      },
    },

    errors: {
      type: Object,
      required: false,
      default: {
        title: '',
        start_date: '',
        end_date: '',
        type: '',
        value: '',
      },
    }
  },

  data() {
    return {
      selectedRadio: 1,

      advanced_options: [
        { value: 1, name: "Active" },
        { value: 0, name: "Inactive" },
      ],

      localData: {
        id: this.data.id || null,
        title: this.data.title || '',
        start_date: this.data.start_date || '',
        end_date: this.data.end_date || '',
        type: this.data.type || '',
        value: this.data.value || 0,
      }

    };
  },

   watch: {
    selectedRadio: function (newVal, oldVal) {
      data.status = newVal;
    },
  },

  methods: {
    hideModal(name) {
      $(name).modal('hide');
    },  

    async handleSubmit() {
      this.localData = { ...this.data, status: this.$props.data.status };

      this.postData = {
        title: this.localData.title,
        start_date: this.localData.start_date,
        end_date: this.localData.end_date,
        type: this.localData.type,
        value: this.localData.value,
        status: this.localData.status,
        product_id: this.localData.product_id,
        id: this.localData.id
      }

      this.$emit("updatePromo", {...this.postData});
    },
  },
};
</script>

<style scoped>
.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #dc3545;
}
</style>
